import type { ObjectType } from 'shared/types';

export const isObject = (value: unknown): value is ObjectType => {
  return typeof value === 'object' && value !== null;
};
